import HriTheme from '../../../web/src/themes/HriTheme';
import MillelacsTheme from '../../../web/src/themes/MillelacsTheme';
import JamulTheme from '../../../web/src/themes/JamulTheme';
import LadyluckTheme from '../../../web/src/themes/LadyluckTheme';
import TiTheme from '../../../web/src/themes/TiTheme';
import SgaTheme from '../../../web/src/themes/SgaTheme';
export var themes = {
  hri: HriTheme,
  sga: SgaTheme,
  ti: TiTheme,
  millelacs: MillelacsTheme,
  jamul: JamulTheme,
  ladyluck: LadyluckTheme
};